import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { LoginService } from '../../shared/service/login/login.service';
import { Usuario } from '../../shared';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { UtilService } from '../../shared/service/util/util.service';
import { ConfirmDialogService } from '../../shared/service/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.css']
})
export class UsuarioListComponent implements OnInit {

  showSpinner: boolean = false;
  dataSource: MatTableDataSource<Usuario>
  userRequests: Usuario[];
  organizacaoId: number;
  usuario: Usuario;
  nomeUsuario: string;
  displayedColumns: string[] = ['nome', 'email', 'status', 'acao'];

  @ViewChild('f', { static: true }) form;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private router: Router,
    private usuarioService: UsuarioService,
    private utilService: UtilService,
    private loginService: LoginService,
    private dialogService: ConfirmDialogService
  ) {
    this.organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;
    this.getUsuarios();
  }

  getUsuarios() {
    this.showSpinner = true;
    this.usuarioService.getUserRequests(this.organizacaoId)
      .then((userRequests) => {
        this.showSpinner = false;
        this.userRequests = userRequests;
        this.dataSource = new MatTableDataSource(userRequests);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }).catch((error) => {
        this.showSpinner = false;
        this.getError(error);
      });
  }

  ngOnInit() {

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onCreateNew() {
    this.router.navigate(['/novo-usuario']);
  }

  openDialogInactive(usr: Usuario) {
    let jsUser = JSON.parse(localStorage.getItem("currentUser"));

    if (jsUser.email == usr.email) {
      this.utilService.showError('Não é possivel desativar este usuário')
    } else {
      const options = {
        title: 'Desativar usuário',
        message: 'Deseja desativar "' + usr.nome + '"?',
        cancelText: 'Cancelar',
        confirmText: 'Desativar'
      };

      this.dialogService.open(options);

      this.dialogService.confirmed().subscribe(confirmed => {
        if (confirmed) {
          usr.ativar = false;
          this.active(usr);
        }
      });
    }
  }

  onActive(usr: Usuario) {
    usr.ativar = true;
    this.active(usr);
  }

  active(usr: Usuario) {
    this.showSpinner = true;
    usr.organizacaoId = this.organizacaoId;

    this.usuarioService.ativarUsuarioPerfilOrganizacao(usr).subscribe(
      () => {
        this.showSpinner = false;

        if (usr.ativar) {
          usr.status = "Ativo";
          this.utilService.showSuccess('Usuário ativado com sucesso');
        } else {
          usr.status = "Desativado";
          this.utilService.showSuccess('Usuário desativado com sucesso');
        }
        this.updateItem(usr);
      },
      err => {
        this.showSpinner = false;
        this.getError(err);
      });
  }

  openConfirmDialogDelete(usr) {
    let jsUser = JSON.parse(localStorage.getItem("currentUser"));

    if (jsUser.email == usr.email) {
      this.utilService.showError('Não é possivel excluir este usuário')
    } else {
      const options = {
        title: 'Excluir usuário',
        message: 'Ao excluir o usuário ' + usr.nome + ', TODOS os CERTIFICADOS já emitidos serão PERDIDOS. Deseja continuar?',
        cancelText: 'Cancelar',
        confirmText: 'Excluir'
      };
  
      this.dialogService.open(options);
  
      this.dialogService.confirmed().subscribe(confirmed => {
        if (confirmed) {
          this.delete(usr);
        }
      });
    }
  }

  onEdit(usr) {
    this.router.navigate(['/novo-usuario', { id: usr.id }]);
  }

  onResetToken(usr) {
    this.router.navigate(['/reset-token', { id: usr.id }]);
  }

  onSendEmail(usr) {
    this.usuarioService.email(usr.id, this.organizacaoId);
    this.utilService.showSuccess('E-mail enviado com sucesso');
  }

  delete(usr) {
    this.showSpinner = true;

    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    usr.organizacaoId = this.organizacaoId;
    usr.idUsuarioAlteracao = currentUser.id;
    usr.emailUsuarioAlteracao = currentUser.email;

    this.usuarioService.excluir(usr).then(
      () => {
        this.showSpinner = false;
        this.utilService.showSuccess('Usuário excluído com sucesso');
        usr.status = "Excluído";
        this.updateItem(usr);
      })
      .catch((error) => {
        this.showSpinner = false;
        this.getError(error);
      });
  }

  updateItem(usrDel: Usuario) {
    let index: number = this.userRequests.findIndex(
      d => d.id === usrDel.id);

    if (index !== -1) {
      this.userRequests[index] = usrDel;
      this.dataSource = new MatTableDataSource<Usuario>(this.userRequests);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  exportRelatorio() {
    this.usuarioService.exportExcel(this.dataSource.filteredData);
  }
  
  isVarejo(): boolean{
    return (localStorage.getItem('isVarejo') === 'true');
  }

  getError(error) {
    if (error.status === 401 || error.status === 403) {
      this.loginService.logout();
    } else {
      let err;

      if (error.status === 0) {
        err = 'Servidor indisponível!';
      } else {
        err = error.message || error;
      }
      this.utilService.showError(err);
    }
  }
}